import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "../../api/constants";
import type { ChatSessionDetail } from "../../api/getChatSession";

// Interfaces
export interface RenameSessionRequest {
  name: string;
}

export interface RenameSessionResponse {
  success: boolean;
  session: ChatSessionDetail;
}

// Axios request
export function renameChatSession(
  session_uid: string,
  name: string,
): Promise<AxiosResponse<RenameSessionResponse>> {
  return axios.patch<RenameSessionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/sessions/${session_uid}/rename`,
    { name } as RenameSessionRequest,
  );
}
